/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
class s{constructor(s=0,a=0){this.min=s,this.max=a,this.level=0,this.hasNoDataValues=!1}copyFrom(s){this.min=s.min,this.max=s.max,this.level=s.level,this.hasNoDataValues=s.hasNoDataValues}}export{s as ElevationBounds};
